/**
 * 日志模块
 */
enum LogType {
	error = 0,
	info
}

const Log = {
	/**
	 * 记录错误信息
	 * @param msg
	 */
	error(msg: string) {
		console.error(msg);
		// 记录错误信息（入库）
		Log._recordLog(msg, LogType.error);
	},
	/**
	 * 记录日志信息
	 * @param msg
	 */
	info(msg: string) {
		console.info(msg);
		Log._recordLog(msg, LogType.info);
	},
	// 记录日志
	_recordLog(msg: string, logType: LogType) {
		// 向统一的日志中心发送日志
	}
};

export default Log;
